import { defineMessages } from 'react-intl'

export default defineMessages({
  sendToWorkgrid: {
    id: 'SpaceAppBuilder.SuggestionBox.sendToWorkgrid',
    defaultMessage: 'Send to Workgrid'
  },
  dismiss: {
    id: 'SpaceAppBuilder.SuggestionBox.dismiss',
    defaultMessage: 'Dismiss'
  },
  suggestionPlaceholder: {
    id: 'SpaceAppBuilder.SuggestionBox.suggestionPlaceholder',
    defaultMessage: 'Let us know which {suggestionType} you would like added'
  },
  close: {
    id: 'SpaceAppBuilder.SuggestionBox.close',
    defaultMessage: 'Close'
  },
  disclaimer: {
    id: 'SpaceAppBuilder.SuggestionBox.Disclaimer',
    defaultMessage:
      '*Feedback submission will include your name and email. Please do not include any confidential or sensitive information.'
  }
})
